import { useEffect, useState } from "react";
import { api } from "../lib/api";

function Empty({ label }) {
  return <tr><td colSpan={6} className="p-8 text-center text-muted_ink">No {label} yet</td></tr>;
}

export function AdminMemberships() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/membership").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="admin-memberships-page">
      <p className="overline text-terracotta mb-2">Submissions</p>
      <h1 className="font-heading font-black text-4xl tracking-tighter text-olive mb-8">Membership Applications</h1>
      <div className="bg-white border border-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-cream border-b border-border">
            <tr className="text-left">
              <th className="p-4 font-semibold">Name</th>
              <th className="p-4 font-semibold">Email</th>
              <th className="p-4 font-semibold">Phone</th>
              <th className="p-4 font-semibold">Marital</th>
              <th className="p-4 font-semibold">Previous Church</th>
              <th className="p-4 font-semibold">Submitted</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? <Empty label="applications" /> : items.map((m) => (
              <tr key={m.id} className="border-b border-border last:border-0">
                <td className="p-4 font-medium text-ink">{m.full_name}</td>
                <td className="p-4 text-muted_ink">{m.email}</td>
                <td className="p-4 text-muted_ink">{m.phone}</td>
                <td className="p-4 text-muted_ink">{m.marital_status || "—"}</td>
                <td className="p-4 text-muted_ink">{m.previous_church || "—"}</td>
                <td className="p-4 text-muted_ink">{new Date(m.created_at).toLocaleDateString("en-ZA")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function AdminJoinTeam() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/join-team").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="admin-jointeam-page">
      <p className="overline text-terracotta mb-2">Submissions</p>
      <h1 className="font-heading font-black text-4xl tracking-tighter text-olive mb-8">Team Applications</h1>
      <div className="bg-white border border-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-cream border-b border-border">
            <tr className="text-left">
              <th className="p-4 font-semibold">Name</th>
              <th className="p-4 font-semibold">Email</th>
              <th className="p-4 font-semibold">Phone</th>
              <th className="p-4 font-semibold">Team</th>
              <th className="p-4 font-semibold">Availability</th>
              <th className="p-4 font-semibold">Submitted</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? <Empty label="team applications" /> : items.map((m) => (
              <tr key={m.id} className="border-b border-border last:border-0">
                <td className="p-4 font-medium text-ink">{m.full_name}</td>
                <td className="p-4 text-muted_ink">{m.email}</td>
                <td className="p-4 text-muted_ink">{m.phone}</td>
                <td className="p-4"><span className="bg-olive text-bone px-2.5 py-1 text-xs font-semibold">{m.team_interest}</span></td>
                <td className="p-4 text-muted_ink">{m.availability || "—"}</td>
                <td className="p-4 text-muted_ink">{new Date(m.created_at).toLocaleDateString("en-ZA")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
